/**
 * @generated SignedSource<<a7f1b91bff00f377a0824092589d5e1b>>
 * @relayHash 754f272822d9292f22e3bad9f2d4cefe
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 867a7a05df9435acddd36b84f6932fe73cdd1d7b12490abe43b1c5c3c851a347

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraReleaseNotesIssueKeyConfig = "LINKED" | "NONE" | "UNLINKED" | "%future added value";
export type JiraVersionReleaseNotesType = "CONFLUENCE_RELEASE_NOTE" | "NATIVE_RELEASE_NOTE" | "%future added value";
export type JiraVersionReleaseNotesConfigurationInput = {
  issueFieldIds: ReadonlyArray<string>;
  issueKeyConfig: JiraReleaseNotesIssueKeyConfig;
  issueTypeIds: ReadonlyArray<string>;
};
export type uiReleaseNotesModalQuery$variables = {
  releaseNoteConfiguration?: JiraVersionReleaseNotesConfigurationInput | null | undefined;
  versionAri: string;
};
export type uiReleaseNotesModalQuery$data = {
  readonly jira: {
    readonly version: {
      readonly __typename: "JiraVersion";
      readonly __id: string;
      readonly availableSites: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly isSystem: boolean;
          };
        } | null | undefined>;
      } | null | undefined;
      readonly canEditRelatedWork: boolean | null | undefined;
      readonly id: string;
      readonly releaseNotesConfiguration: {
        readonly issueFieldIds: ReadonlyArray<string | null | undefined>;
        readonly issueKeyConfig: JiraReleaseNotesIssueKeyConfig;
        readonly issueTypeIds: ReadonlyArray<string | null | undefined>;
      };
      readonly releaseNotesOptionsIssueTypes: {
        readonly edges: ReadonlyArray<{
          readonly " $fragmentSpreads": FragmentRefs<"ui_softwareReleasesAddReleaseNotesModal_ReleaseNotesModal_jiraIssueTypeEdges">;
        } | null | undefined>;
      };
      readonly releasesNotesPreferenceType: JiraVersionReleaseNotesType | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"analyticsContext_softwareReleasesAddReleaseNotesModal_ReleaseNotesModalAnalyticsContext" | "formattingOptions_softwareReleasesAddReleaseNotesModal" | "ui_softwareReleasesAddReleaseNotesModal_ReleaseNotesModalContent_version" | "versionSelector_softwareReleasesAddReleaseNotesModal">;
    } | {
      readonly __typename: "QueryError";
      readonly message: string | null | undefined;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    };
  };
};
export type uiReleaseNotesModalQuery = {
  response: uiReleaseNotesModalQuery$data;
  variables: uiReleaseNotesModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "releaseNoteConfiguration"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "versionAri"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "versionAri"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "kind": "ScalarField",
  "name": "canEditRelatedWork"
},
v6 = {
  "kind": "ScalarField",
  "name": "releasesNotesPreferenceType"
},
v7 = {
  "kind": "ScalarField",
  "name": "issueKeyConfig"
},
v8 = {
  "kind": "ScalarField",
  "name": "issueFieldIds"
},
v9 = {
  "kind": "ScalarField",
  "name": "issueTypeIds"
},
v10 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
],
v11 = [
  {
    "kind": "Variable",
    "name": "releaseNoteConfiguration",
    "variableName": "releaseNoteConfiguration"
  }
],
v12 = {
  "kind": "ScalarField",
  "name": "isSystem"
},
v13 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v14 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ],
  "type": "QueryError"
},
v15 = {
  "kind": "ScalarField",
  "name": "name"
},
v16 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v17 = {
  "kind": "ScalarField",
  "name": "endCursor"
},
v18 = {
  "kind": "ScalarField",
  "name": "hasNextPage"
},
v19 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
],
v20 = [
  {
    "concreteType": "PageInfo",
    "kind": "LinkedField",
    "name": "pageInfo",
    "plural": false,
    "selections": [
      (v18/*: any*/),
      (v17/*: any*/)
    ]
  },
  {
    "concreteType": "JiraIssueFieldEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v15/*: any*/)
        ]
      },
      (v16/*: any*/)
    ]
  }
],
v21 = [
  "searchString"
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "uiReleaseNotesModalQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v2/*: any*/),
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "RequiredField",
                        "field": (v4/*: any*/),
                        "action": "THROW",
                        "path": "jira.version.id"
                      },
                      (v5/*: any*/),
                      (v6/*: any*/),
                      {
                        "kind": "RequiredField",
                        "field": {
                          "concreteType": "JiraReleaseNotesConfiguration",
                          "kind": "LinkedField",
                          "name": "releaseNotesConfiguration",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "RequiredField",
                              "field": (v7/*: any*/),
                              "action": "THROW",
                              "path": "jira.version.releaseNotesConfiguration.issueKeyConfig"
                            },
                            {
                              "kind": "RequiredField",
                              "field": (v8/*: any*/),
                              "action": "THROW",
                              "path": "jira.version.releaseNotesConfiguration.issueFieldIds"
                            },
                            {
                              "kind": "RequiredField",
                              "field": (v9/*: any*/),
                              "action": "THROW",
                              "path": "jira.version.releaseNotesConfiguration.issueTypeIds"
                            }
                          ]
                        },
                        "action": "THROW",
                        "path": "jira.version.releaseNotesConfiguration"
                      },
                      {
                        "kind": "RequiredField",
                        "field": {
                          "args": (v10/*: any*/),
                          "concreteType": "JiraIssueTypeConnection",
                          "kind": "LinkedField",
                          "name": "releaseNotesOptionsIssueTypes",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "RequiredField",
                              "field": {
                                "concreteType": "JiraIssueTypeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "FragmentSpread",
                                    "name": "ui_softwareReleasesAddReleaseNotesModal_ReleaseNotesModal_jiraIssueTypeEdges"
                                  }
                                ]
                              },
                              "action": "THROW",
                              "path": "jira.version.releaseNotesOptionsIssueTypes.edges"
                            }
                          ],
                          "storageKey": "releaseNotesOptionsIssueTypes(first:100)"
                        },
                        "action": "THROW",
                        "path": "jira.version.releaseNotesOptionsIssueTypes"
                      },
                      {
                        "args": (v11/*: any*/),
                        "kind": "FragmentSpread",
                        "name": "ui_softwareReleasesAddReleaseNotesModal_ReleaseNotesModalContent_version"
                      },
                      {
                        "kind": "FragmentSpread",
                        "name": "formattingOptions_softwareReleasesAddReleaseNotesModal"
                      },
                      {
                        "kind": "FragmentSpread",
                        "name": "analyticsContext_softwareReleasesAddReleaseNotesModal_ReleaseNotesModalAnalyticsContext"
                      },
                      {
                        "kind": "FragmentSpread",
                        "name": "versionSelector_softwareReleasesAddReleaseNotesModal"
                      },
                      {
                        "concreteType": "JiraReleaseNotesInConfluenceAvailableSitesConnection",
                        "kind": "LinkedField",
                        "name": "availableSites",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "RequiredField",
                            "field": {
                              "concreteType": "JiraReleaseNotesInConfluenceAvailableSitesEdge",
                              "kind": "LinkedField",
                              "name": "edges",
                              "plural": true,
                              "selections": [
                                {
                                  "kind": "RequiredField",
                                  "field": {
                                    "concreteType": "JiraReleaseNotesInConfluenceAvailableSite",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "RequiredField",
                                        "field": (v12/*: any*/),
                                        "action": "LOG",
                                        "path": "jira.version.availableSites.edges.node.isSystem"
                                      }
                                    ]
                                  },
                                  "action": "LOG",
                                  "path": "jira.version.availableSites.edges.node"
                                }
                              ]
                            },
                            "action": "LOG",
                            "path": "jira.version.availableSites.edges"
                          }
                        ]
                      },
                      (v13/*: any*/)
                    ],
                    "type": "JiraVersion"
                  },
                  (v14/*: any*/)
                ]
              },
              "action": "THROW",
              "path": "jira.version"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "uiReleaseNotesModalQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "version",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "concreteType": "JiraReleaseNotesConfiguration",
                    "kind": "LinkedField",
                    "name": "releaseNotesConfiguration",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/)
                    ]
                  },
                  {
                    "args": (v10/*: any*/),
                    "concreteType": "JiraIssueTypeConnection",
                    "kind": "LinkedField",
                    "name": "releaseNotesOptionsIssueTypes",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraIssueTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraIssueType",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v15/*: any*/),
                              {
                                "concreteType": "JiraAvatar",
                                "kind": "LinkedField",
                                "name": "avatar",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "xsmall"
                                  }
                                ]
                              },
                              (v3/*: any*/)
                            ]
                          },
                          (v16/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                          (v17/*: any*/),
                          (v18/*: any*/)
                        ]
                      }
                    ],
                    "storageKey": "releaseNotesOptionsIssueTypes(first:100)"
                  },
                  {
                    "args": (v10/*: any*/),
                    "handle": "connection",
                    "key": "issueTypeSelector_releaseNotesOptionsIssueTypes",
                    "kind": "LinkedHandle",
                    "name": "releaseNotesOptionsIssueTypes"
                  },
                  {
                    "args": (v11/*: any*/),
                    "concreteType": "JiraADF",
                    "kind": "LinkedField",
                    "name": "releaseNotes",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "json"
                      }
                    ]
                  },
                  {
                    "args": (v19/*: any*/),
                    "concreteType": "JiraIssueFieldConnection",
                    "kind": "LinkedField",
                    "name": "releaseNotesOptionsIssueFields",
                    "plural": false,
                    "selections": (v20/*: any*/),
                    "storageKey": "releaseNotesOptionsIssueFields(first:10)"
                  },
                  {
                    "args": (v19/*: any*/),
                    "filters": (v21/*: any*/),
                    "handle": "connection",
                    "key": "issueFieldSelectors_releaseNotesOptionsIssueFields",
                    "kind": "LinkedHandle",
                    "name": "releaseNotesOptionsIssueFields"
                  },
                  {
                    "args": (v19/*: any*/),
                    "concreteType": "JiraIssueFieldConnection",
                    "kind": "LinkedField",
                    "name": "nativeReleaseNotesOptionsIssueFields",
                    "plural": false,
                    "selections": (v20/*: any*/),
                    "storageKey": "nativeReleaseNotesOptionsIssueFields(first:10)"
                  },
                  {
                    "args": (v19/*: any*/),
                    "filters": (v21/*: any*/),
                    "handle": "connection",
                    "key": "issueFieldSelectors_nativeReleaseNotesOptionsIssueFields",
                    "kind": "LinkedHandle",
                    "name": "nativeReleaseNotesOptionsIssueFields"
                  },
                  {
                    "concreteType": "JiraReleaseNotesInConfluenceAvailableSitesConnection",
                    "kind": "LinkedField",
                    "name": "availableSites",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraReleaseNotesInConfluenceAvailableSitesEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraReleaseNotesInConfluenceAvailableSite",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  (v13/*: any*/)
                ],
                "type": "JiraVersion"
              },
              (v14/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v4/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "867a7a05df9435acddd36b84f6932fe73cdd1d7b12490abe43b1c5c3c851a347",
    "metadata": {},
    "name": "uiReleaseNotesModalQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "80ac19b81c283c7bcb3b96a66b1f7cae";

export default node;
